<template>
  <div class="dialog">
    <span class="cls" @click="oth_showPicker(false)"></span>
    <div class="paper">
      <div class="header"> <h2>세트 내용 수정</h2></div>
      <ul class="collect">
        <li v-for="item in localSetList" :key="item.idx">
          <img :src="item.cover"/>
          <span>{{ item.title }}</span>
          <span>{{ getCategory(item.category).name }}</span>
        </li>
      </ul>
      <ul class="list-ts">
        <li v-for="item in counselList" :key="item.idx" :class="{active: localSetList.some(counsel => counsel.idx === item.idx)}">
          <img :src="item.cover" @click="selectCounsel(item)" />
          <div class="description" @click="selectCounsel(item)">
            <h2>{{ item.title }}</h2>
            <span>{{ item.description }}</span>
            <span>{{ getCategory(item.category).name }}</span>
          </div>
        </li>
      </ul>
      
      <div class="btns">
        <button class="save" @click="save">저장</button>
      </div>
    </div>
  </div>
</template>



<script>
import { ref } from 'vue';

export default {
  props: {
    oth_showPicker: {
      type: Function,
      required: true
    },
    setList: {
      type: Array,
      required: false,
      default: () => []
    },
    counselList: {
      type: Array,
      required: false,
      default: () => []
    }
  },
  setup(props, { emit }) {   // 여기서 emit 받아오기

    const localSetList = ref([...props.setList])
    
    const categoryList = [
      {name:"자기소개", value:"self_intro"},
      {name:"아이스브레이킹", value:"ice_break"},
      {name:"니즈환기", value:"needs_awake"},
      {name:"실제예시", value:"real_example"},
      {name:"해결제안", value:"solution_proposal"},
      {name:"거절반격", value:"rejection_counter"},
      {name:"클로징", value:"closing"},
      {name:"사후관리", value:"aftercare"},
      {name:"기타", value:"etc"},
    ];

    function selectCounsel(item) {

      // 만약 counselList 안에 item 이 있다면
      if (localSetList.value.some(counsel => counsel.idx === item.idx)) {
        // setList에서 item을 제거
        const index = localSetList.value.findIndex(counsel => counsel.idx === item.idx);
        if (index !== -1) { localSetList.value.splice(index, 1); }
        console.log(localSetList.value);
        return;
      } else {
        // setList에 item 추가
        localSetList.value.push(item);
        console.log(localSetList.value);
        return;
      }
    }

    function getCategory(value) {
      const category = categoryList.find(cat => cat.value === value);
      return category ? category : {name:"알수없음", value:"unknown"};
    }

    function save() {

      let saveJSON = [];
      for (let i = 0; i < localSetList.value.length; i++) 
      {
        saveJSON.push({
          order: i + 1,
          counsel_idx: localSetList.value[i].idx
        });
      }

      let jsonData = JSON.stringify(saveJSON);
      console.log('저장된 세트:', jsonData);
      emit('submit', saveJSON);
      props.oth_showPicker(false);
    }

    return {
      selectCounsel,
      categoryList,
      getCategory,
      localSetList,
      save
    };
  },
};
</script>


<style scoped>
.dialog {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  backdrop-filter: blur(2px);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99999 !important;
}

.dialog .cls {
  width:100%;
  height:100%;
  position:absolute;
  left:0;
  top:0;
  z-index: -1;
}

.dialog .paper {
  width: 90%;
  max-width: 600px;
  min-height: 10%;
  height:80%;
  background: var(--color-background);
  border: 2px solid var(--color-background-light);
  border-radius: 16px;
  padding: 16px;
  box-sizing: border-box;
  gap: 24px;
  display: flex;
  flex-direction: column;
}

.dialog .paper ul.collect {
  width: 100%;
  height:fit-content;
  margin:0;
  padding:0;
  list-style:none;
  display: flex;
  gap: 8px;
  box-sizing: border-box;
}

.dialog .paper ul.collect > li {
  position: relative;
  width:60px;
  height:fit-content;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  display: flex;
  flex-direction: column;
  gap:6px;
}

.dialog .paper ul.collect > li > img {
  width:60px;
  height:60px;
  border-radius: 4px;
  object-fit: cover;
  background: var(--color-surface-reverse);
}

.dialog .paper ul.collect > li > span {
  width:100%;
  text-align: center;
  font-size: var(--font-size-base);
  color: var(--color-text-primary);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.dialog .paper ul.collect > li > .del {
  position: absolute;
  z-index:9;
  top:6px;
  right:6px;
  width:20px;
  height:20px;
  background:transparent;
  border:none;
  color: var(--color-special-warning);
  cursor: pointer;
  padding:0;
  box-sizing: border-box;
  font-size: 12px;
}

.dialog .paper ul.list-ts {
  width:100%;
  height: calc(100% - 40px);
  margin:0;
  padding:0;
  list-style:none;
  overflow-y: auto;
  display: flex;
  flex-direction: column;
  gap: 8px;
}

.dialog .paper ul.list-ts > li {
  width:100%;
  height:60px;
  box-sizing: border-box;
  border-radius: 4px;
  cursor: pointer;
  color: var(--color-text-primary);
  display:flex;
  justify-content: start;
  align-items: center;
  font-size: 14px;
  gap:12px;
}

.dialog .paper ul.list-ts > li.active {
  background: var(--color-surface-reverse);
}

.dialog .paper ul.list-ts > li > img {
  width:60px;
  height:60px;
  border-radius: 4px;
  object-fit: cover;
}

.dialog .paper ul.list-ts > li > .description {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: start;
  width:100%;
  height:100%;
  gap:4px;
}

.dialog .paper ul.list-ts > li > .description > h2 {
  margin:0;
  font-size: 16px;
  color: var(--color-text-primary);
}

.dialog .paper ul.list-ts > li > .description > span {
  width:100%;
  max-width: 90%;
  text-overflow: ellipsis;
  overflow: hidden;
  white-space: nowrap;
}

.dialog .paper ul.list-ts > li > button {
  height:32px;
  border:none;
  border-radius: 8px;
  background: var(--color-special-accent);
  color: var(--color-text-primary);
  cursor: pointer;
  padding:0 12px;
  box-sizing: border-box;
}

.dialog .paper .btns {
  width:100%;
  display:flex;
  justify-content: center;
  align-items: center;
  gap:12px;
}

.dialog .paper .btns > button {
  width:100%;
  height:36px;
  flex:1;
  border:none;
  border-radius: 8px;
  cursor: pointer;
  font-size: 14px;
  color: var(--color-text-primary);
}

.dialog .paper .btns > button.del {
  background: var(--color-special-warning);
}

.dialog .paper .btns > button.save {
  background: var(--color-special-accent);
}
</style>